<template>
  <v-app id="register" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-6 pa-3">
              <v-card-text v-show="!viewAnswer">
                <div class="layout column align-center">
                  <v-spacer></v-spacer>
                  <h1 class="text-md-center">Change Password</h1>
                </div>
                <v-form>
                  <v-text-field append-icon="person" name="login" label="Benutzername" v-on:change="getQuestion" type="text" v-model="model.email"></v-text-field>
                  <v-text-field append-icon="person" name="securityQ" readonly label="Frage" type="text" v-model="model.securityQ"></v-text-field>
                  <v-text-field append-icon="person" name="securityAnswer" label="Antworten" type="text" v-model="model.securityAnswer"></v-text-field>
               </v-form>
                <div v-if="error" class="v-alert v-alert--outline error--text">
                  <i aria-hidden="true" class="v-icon material-icons v-alert__icon">warning</i>
                  <div>
                    {{error}}
                  </div>
                </div>
              </v-card-text>
              <v-card-actions v-show="!viewAnswer">
                <v-flex mt-2>
                  <v-btn block color="primary" @click="changePassword" :loading="loading">Change password</v-btn>
                </v-flex>
              </v-card-actions>
              <v-card-text v-show="viewAnswer">
                <div class="layout column align-center">
                  <div>
                    {{answer}}
                  </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-flex mt-2>
                  <a href="#/login">Back to Login</a>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>


<script>
import Vue from 'vue'
import API from '@/api'
import securityQuestions from './securityquestion.json'

export default {
  data: () => ({
    error: '',
    loading: false,
    viewAnswer: false,
    answer: "",
    model: {
      email: '',
      password: '',
      passwordRepeat: '',
      team: [],
      securityQ :""
    },
    teams: []
  }),

  methods: {
    async getQuestion() {
      let securityAnswer = await API.getSecurityQ(this.model.email);
      if (securityAnswer && securityAnswer.securityQuestionID) {
        this.model.securityQ = securityQuestions[securityAnswer.securityQuestionID - 1].name;
      } else {
        this.model.securityQ = "nie";
      }
      
    },
    containsDisallowedStrings(str) {
      const dissalowChars = ['#', 'http', '<', '>', '#', ':', '&', '/', '\\', 'src', 'script', '=', ')', '(', '%', ',', ';', '+', '*'];
      for (let i = 0; i < dissalowChars.length; i++) {
        const disallowedStr = dissalowChars[i];
        if (str.includes(disallowedStr)) {
          return true; // Disallowed string found
        }
      }
      return false; // No disallowed strings found
    },

    async changePassword () {
      let result = await API.changePassword(this.model.email, this.model.securityAnswer);
      if (result && result.securityAnswer) {
        this.viewAnswer = true;
        this.answer = result.securityAnswer;
      } 
    }
  }
}
</script>
<style scoped lang="css">
  #register {
    color:#223056!important;
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
